import { useQuery } from "@tanstack/react-query";
import queryKey from "../../../../enumerations/queryKey";
import { getAgentFeeBetBonus, getAgentFeeBonus, getAgentFeeLevelBonus } from "../service";

export const useGetAgentFeeBonus = ({ params, options }) => {
  const _arrParams = Object.keys(params).map((key) => params[key]);
  return useQuery(
    [queryKey.AGENT_FEE_BONUS, ..._arrParams],
    () => getAgentFeeBonus({ params }).then((res) => res.data),
    {
      ...options,
    },
  );
};

export const useGetAgentFeeBetBonus = ({ params, options }) => {
  Object.keys(params).forEach((key) => {
    if (params[key] === null || params[key] === undefined || params[key] === "") {
      delete params[key];
    }
  });
  const _arrParams = Object.keys(params).map((key) => params[key]);
  return useQuery(
    [queryKey.AGENT_FEE_BET_BONUS, ..._arrParams],
    () => getAgentFeeBetBonus({ params }).then((res) => res.data.data),
    {
      ...options,
    },
  );
};

export const useGetAgentFeeLevelBonus = ({ params, options }) => {
  Object.keys(params).forEach((key) => {
    if (params[key] === null || params[key] === undefined || params[key] === "") {
      delete params[key];
    }
  });
  const _arrParams = Object.keys(params).map((key) => params[key]);
  return useQuery(
    [queryKey.COMISSION_LEVEL, ..._arrParams],
    () => getAgentFeeLevelBonus({ params }).then((res) => res.data.data),
    {
      ...options,
    },
  );
};
